import React from "react";
import PropTypes from "prop-types";
import PointsTopDesktop from "./PointsTopDesktop";

function PositivacaoCategory({ app, config }) {
  return <PointsTopDesktop app={app} config={config} />;
}

PositivacaoCategory.defaultProps = {
  app: null,
  config: {},
};

PositivacaoCategory.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoCategory;
